import { Fragment } from 'react'

import { BadgeImage } from '~/shared/types/bootcampBadge.types'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '110px' }]
export default function QuizResultBadge({
  badgeImage,
  className,
}: {
  badgeImage: BadgeImage
  className?: string
}): React.ReactElement {
  if (badgeImage.srcKey?.length > 0) {
    return (
      <div className={`flex m-auto ${className}`}>
        <ResponsiveImage
          alt={badgeImage.alt}
          fit="contain"
          height={110}
          imageWidths="100"
          mediaQuery={mediaQuery}
          srcKey={badgeImage.srcKey}
          width={110}
        />
      </div>
    )
  }

  return <Fragment />
}
